import Colors from "../../../../../general/constants/colors";

export const ListItemStyles = {
	paddingBottom: 0,
	paddingTop: 0,
	cursor: "pointer",
	transition: 'background-color .3s ease',
	'&:hover': {
		backgroundColor: Colors.GREY_LIGHT_2,
	},
}